var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDenimwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "katman 2",
    viewBox: "0 0 12.64 10.77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.53 0.31 12.11 0.31 6.32 10.17",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: ".61px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenimwear);
export default __webpack_public_path__ + "static/media/DENIMWEAR.32bbb80dd94ce69b14c34c1435c613a6.svg";
export { ForwardRef as ReactComponent };